import About from './About';

export { queryKey, getAboutCompany } from './queries';

export default About;
